/** Pendentes de classificação: o que o grupo do usuário ainda não aprovou nem reprovou. */

import { Navigate } from "react-router-dom";

import { TabelaEnvios } from "@/components/aprovacoes/TabelaEnvios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { usePendentes } from "@/hooks/queries";
import { useAuth } from "@/lib/auth";

export function PendentesPage() {
  const { tipoAprovacao } = useAuth();
  const { data: envios, isLoading } = usePendentes(Boolean(tipoAprovacao));

  if (!tipoAprovacao) return <Navigate to="/minhas-operacoes" replace />;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Pendentes de classificação</CardTitle>
      </CardHeader>

      <CardContent>
        {isLoading || !envios ? (
          <Skeleton className="h-40 w-full" />
        ) : envios.length === 0 ? (
          <p className="py-8 text-center text-sm text-muted-foreground">
            Nada pendente.
          </p>
        ) : (
          <TabelaEnvios
            envios={envios}
            mostrarAutor
            origem={{ para: "/pendentes", rotulo: "Pendentes de classificação" }}
          />
        )}
      </CardContent>
    </Card>
  );
}
